module.exports = __webpack_public_path__ + "assets/img/SHB.5ebbe28b.png";